import FileSaver from 'file-saver'
import { baseApi } from './base'

type SUPPORTED_OS = 'windows' | 'macos'

export const dmpConnectApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDmpConnectDcParameter: builder.query<string, void>({
      query: () => '/dmp-connect/dcparameter',
    }),
    getDmpConnectBuildDownload: builder.query<{ filename: string }, SUPPORTED_OS>({
      query: (os) => ({
        url: `/dmp-connect/build/download?os=${os}`,
        cache: 'no-cache',
        responseHandler: async (response) => {
          const blob = await response.blob()

          // Extract filename from Content-Disposition header
          const contentDisposition = response.headers.get('Content-Disposition')
          console.log('🚀 ~ contentDisposition:', contentDisposition)
          let filename = `dmpconnect-${os}.${os === 'macos' ? 'dmg' : 'exe'}` // Fallback filename

          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/)
            if (filenameMatch?.[1]) {
              filename = filenameMatch[1]
            }
          }

          FileSaver.saveAs(blob, filename)

          return { filename }
        },
      }),
    }),
    getDmpConnectBuildVersion: builder.query<string, SUPPORTED_OS>({
      query: (os) => ({ url: `/dmp-connect/build/version?os=${os}` }),
    }),
  }),
  overrideExisting: false,
})
